export const HTML_BASE_NAME = `${process.env.PUBLIC_URL.replace(/\/$/, '')}` || '';

export const RegExps = {
  firstNameRegExp: new RegExp('^(?=^.{2,40}$)^[\\p{L}\'][ \\p{L}\'-]*[\\p{L}]$', 'u'),
  lastNameRegExp: new RegExp('^(?=^.{2,80}$)^[\\p{L}\'][ \\p{L}\'-]*[\\p{L}]$', 'u'),
  emailRegExp: new RegExp('^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\\-+)|([A-Za-z0-9]+\\.+)|([A-Za-z0-9]+\\++))*[_A-Za-z0-9]+@((\\w+\\-+)|(\\w+\\.))*\\w{1,63}\\.[a-zA-Z]{2,6}$'),
  phoneRegExp: new RegExp('^[0-9]{9}$'),
};




// WEBPACK FOOTER //
// ./src/commons/constants.js